/* eslint-disable import/no-extraneous-dependencies */
import { useState } from "react";
import { LexicalComposer } from "@lexical/react/LexicalComposer";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { $generateHtmlFromNodes } from "@lexical/html";
import { lexicalEditorConfig } from "../components/lexical-editor/lexicalEditorConfig";
 

export const useMenuGetHtmlFromState = (state) => {
  const [menuhtml, setMenuHtml] = useState("");

  const MenuAuxEditor = () => {
    // Create a new configuration object for each instance
    const editorConfig = { ...lexicalEditorConfig };

    if (state !== undefined) {
      editorConfig.editorState = state;
    }

    function MyCustomStateToHtmlPlugin() {
      const [editor1] = useLexicalComposerContext();
      editor1.update(() => {
        const html = $generateHtmlFromNodes(editor1, null);
        setMenuHtml(html);
      });

      return null;
    }

    return (
      <LexicalComposer initialConfig={editorConfig}>
        <MyCustomStateToHtmlPlugin />
      </LexicalComposer>
    );
  };

  return { menuhtml, MenuAuxEditor };
};
